import { ApiResponse } from 'apisauce';

import config from '../../config';
import { PredefinedMilisecondsTypeEnum } from '../enums';
import { FILE_REQUEST_TIMEOUT } from '../libSettings';
import { UserPreferencesRequest } from '../store/file/types';

import { CacheService } from './cache/Cache.service';
import { CacheName, HttpMethods } from './cache/types';
import { BaseRequestService } from './BaseRequest.service';
import { IFileService } from './types';

const API_PATH = {
  get: '/File',
  upload: '/File',
  deleteByName: '/File?fileName=',
  userPreferences: '/File/user-preferences',
};

const cacheService = CacheService.getService();

export class FileService extends BaseRequestService implements IFileService {
  private static instance: FileService;

  protected getBaseUrl(): string {
    return config.file.url;
  }

  private constructor() {
    super(FILE_REQUEST_TIMEOUT);
  }

  static getInstance(): FileService {
    if (!this.instance) {
      this.instance = new FileService();
    }
    return this.instance;
  }

  get(fileName: string): Promise<ApiResponse<string>> {
    if (!fileName) {
      throw new Error('[File.service] File name not provided');
    }

    return this.api.get<string>(`${API_PATH.get}/${fileName}`);
  }

  async upload(data: string, fileName: string) {
    if (!data) {
      throw new Error('[File.service] No file data given');
    }

    return this.api.post<any[]>(API_PATH.upload, {
      fileName,
      fileData: data,
    });
  }

  async uploadUserPreferenceFile(data: UserPreferencesRequest) {
    if (!data) {
      throw new Error('[File.service] No file data given');
    }

    cacheService.evictCache(`${CacheName.favoriteList}:${HttpMethods.GET}`);
    return this.api.post<UserPreferencesRequest>(API_PATH.userPreferences, data);
  }

  async getUserPreferenceFile(preferenceName: string) {
    const APIPath = `${API_PATH.userPreferences}/${preferenceName}`;
    const url = this.getBaseUrl() + APIPath;
    this.addOrUpdateCacheDefinition(
      url,
      CacheName.favoriteList,
      HttpMethods.GET,
      PredefinedMilisecondsTypeEnum.oneMinute,
    );
    return this.api.get(APIPath);
  }

  deleteByName(fileName: string): Promise<ApiResponse<null>> {
    return this.api.delete<null>(API_PATH.deleteByName + fileName);
  }
}
